import { createSlice } from '@reduxjs/toolkit';

const searchDataSlice = createSlice({
  name: 'searchData',
  initialState: {
    data: []
  },
  reducers: {
    info(state, action) {
      state.data = action.payload.searchInfo;
    }
  }
});

export const searchDataActions = searchDataSlice.actions;

export default searchDataSlice;
